module.exports = __webpack_public_path__ + "static/preview-5e0705132b3941305812e9cf6e2c4f6e.jpg";